export function deepMerge<T>(target: T, source: Partial<T>): T {
    if (typeof target !== 'object' || target === null) return target;
    if (typeof source !== 'object' || source === null) return target;

    const result = { ...target } as T;

    for (const key in source) {
        const sourceValue = source[key];
        const targetValue = target[key];

        if (sourceValue === undefined) continue;

        if (
            typeof sourceValue === 'object' &&
            sourceValue !== null &&
            !Array.isArray(sourceValue) &&
            typeof targetValue === 'object' &&
            targetValue !== null &&
            !Array.isArray(targetValue)
        ) {
            result[key] = deepMerge(targetValue, sourceValue);
        } else {
            result[key] = sourceValue as T[typeof key];
        }
    }

    return result;
}